export const contactsRouteNames = {
  default: 'contacts-v2',
  smartList: 'smart-list-v2',
  importFilter: 'import_filter-v2',
  //TODO:inform the contacts team about the name change
  import: 'contacts-imports',
  businessName: 'business_name-v2',
  bulkActions: 'bulk-actions-log-v2',
  duplicates: 'bulk-duplicates',
  contactDetail: 'contact_detail-v2',
  contactRestore: 'contact_restore-v2',
}
